import { render, staticRenderFns } from "./CooperadosModal.vue?vue&type=template&id=057aa710"
import script from "./CooperadosModal.vue?vue&type=script&lang=js"
export * from "./CooperadosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports